import React from 'react'
import { Notice } from '..'

export const SubmitError = ({ submitError }) =>
  submitError ? <Notice error title={submitError} /> : null
